import React from 'react';
import { FaTools, FaRocket, FaBuilding, FaPeopleArrows, FaGlassCheers } from 'react-icons/fa';
import { MdFace } from "react-icons/md";
import { motion } from 'framer-motion';
import aboutImage from '../style/thermal_img/375.jpg'; // Ensure you have an image for the about section
import WhyCatapult from './WhyCatapult';
import WhatWeDo from './WhatWeDo';


const ServiceCard = ({ icon: Icon, title, description }) => (
  <motion.div
    className="service-item"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    <Icon size={40} style={{ marginBottom: '1rem', color: '#8a0000' }} />
    <h3>{title}</h3>
    <p>{description}</p>
  </motion.div>
);

const AboutUs = () => {
  return (
    <>
      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-text">
            <h2 className="section-title">Our Story</h2>
            <h3 className="about-subtitle">Trusted Industrial Heater Manufacturers in India</h3>
            <div className="about-divider"></div>
            <p>
              <strong>01</strong><br />
              <b>Amrita Thermal Engineering (ATE)</b> is a renowned name among industrial heater manufacturers in India, offering premium quality ceramic mica band heaters, water oil and chemical immersion heaters , custom design heaters , hot runner heaters, manifold heaters that excel in both efficiency and durability. We are trusted for providing advanced heating solutions that cater to diverse industrial needs. Additionally, as commercial heater manufacturers, we are authorized distributors for leading brands like Opkon, Maxthermo, Ceramicx, and Optris.
            </p>
            <p>
              Our comprehensive product range includes Linear Displacement Transducers, Rotary Encoders, Pressure Sensors, Infrared Heaters, Thermocouples, Thermal Imaging Systems, and Temperature Controllers. Explore our offerings today and elevate your operations with top-tier industrial heating solutions.
            </p>
            <a href="#services" className="discover-button">Discover our services</a>
          </div>

          <div className="about-image">
            {/* Optional image */}
            <img src={aboutImage} alt="Amrita Thermal Engineering (ATE) About Us" />
          </div>
        </div>
      </section>

      <WhatWeDo />

      <section id="services" className="section">
        <div className="container">
          <h2 className="section-title">Our Team</h2>
          <div className="section-divider"></div>

          <div className="service-blocks">
            <ServiceCard icon={MdFace} title="Sivan Gopalan" description="Director Technical" />
            <ServiceCard icon={MdFace} title="Sandhya P" description="Director Administration and Finance" />
            <ServiceCard icon={MdFace} title="Amit PS" description="Director Business Development" />
            {/* <ServiceCard icon={FaPeopleArrows} title="MICE" description="We organize Meetings, Incentives, Conferences, and Exhibitions that help you grow and engage globally." />
            <ServiceCard icon={FaGlassCheers} title="Social Events" description="Celebrate special moments in style with our full-service planning for weddings and milestone events." /> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
